<div
  class="absolute top-0 bottom-0 flex w-full flex-col items-center justify-center">
  <div class="pb-4 text-3xl font-bold">
    {{
      textStore.texts()
        | filterTexts: ERelationType.errorPageTitle : EEntityType.generic
        | language
    }}
  </div>
  <div class="flex flex-col gap-2 py-6">
    @for (error of errorHandlingService.errors; track error) {
      <div class="rounded-md border-b-red-700 bg-red-200 p-6 text-red-700">
        {{ error }}
      </div>
    } @empty {
      @for (error of errorsFromUrl; track error) {
        <div class="rounded-md border-b-red-700 bg-red-200 p-6 text-red-700">
          {{ error }}
        </div>
      } @empty {
        <div
          class="rounded-md border-b-green-700 bg-green-200 p-6 text-green-700">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noErrors : EEntityType.generic
              | language
          }}
        </div>
      }
    }
  </div>
  <a [routerLink]="'/'" class="text-input-focus text-xl font-semibold">{{
    textStore.texts()
      | filterTexts: ERelationType.backToShop : EEntityType.generic
      | language
  }}</a>
</div>
